var _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _line, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPromoText(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 359,
    height: 136,
    viewBox: "0 0 359 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2816_669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343 5L345.956 13.0443L354 16L345.956 18.9557L343 27L340.044 18.9557L332 16L340.044 13.0443L343 5Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2816_669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.5 7L319.247 11.7534L324 13.5L319.247 15.2466L317.5 20L315.753 15.2466L311 13.5L315.753 11.7534L317.5 7Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2816_669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.5 25L325.784 31.216L332 33.5L325.784 35.784L323.5 42L321.216 35.784L315 33.5L321.216 31.216L323.5 25Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7059 74.0169V94.4944H0V35.5056H17.1407C24.3872 35.5056 28.0105 39.1573 28.0105 46.4607V63.0618C28.0105 70.3652 24.3872 74.0169 17.1407 74.0169H11.7059ZM16.3046 47.7247C16.3046 46.3202 15.6078 45.618 14.2143 45.618H11.7059V63.9045H14.2143C15.6078 63.9045 16.3046 63.2022 16.3046 61.7978V47.7247Z",
    fill: "url(#paint0_linear_2816_669)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6015 66.6011C58.0018 67.5562 59.7019 70.0843 59.7019 74.1854V94.4944H47.996V74.2697C47.996 72.8652 47.2993 72.1629 45.9057 72.1629H42.9792V94.4944H31.2734V35.5056H48.7485C55.995 35.5056 59.6183 39.1573 59.6183 46.4607V57.8371C59.6183 62.4438 57.946 65.3652 54.6015 66.6011ZM47.9124 47.8933C47.9124 46.4888 47.2156 45.7865 45.8221 45.7865H42.9792V62.1348H45.8221C47.2156 62.1348 47.9124 61.4326 47.9124 60.0281V47.8933Z",
    fill: "url(#paint1_linear_2816_669)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7057 84.0449C92.7057 91.3483 89.0824 95 81.8359 95H74.3107C67.0642 95 63.441 91.3483 63.441 84.0449V45.9551C63.441 38.6517 67.0642 35 74.3107 35H81.8359C89.0824 35 92.7057 38.6517 92.7057 45.9551V84.0449ZM80.9998 47.2191C80.9998 45.8146 80.303 45.1124 78.9095 45.1124H77.2372C75.8436 45.1124 75.1469 45.8146 75.1469 47.2191V82.7809C75.1469 84.1854 75.8436 84.8876 77.2372 84.8876H78.9095C80.303 84.8876 80.9998 84.1854 80.9998 82.7809V47.2191Z",
    fill: "url(#paint2_linear_2816_669)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M113.649 35.5056L117.078 71.1517L120.589 35.5056H137.563V94.4944H126.024V55.8146L121.593 94.4944H110.556L106.124 55.3933V94.4944H96.7596V35.5056H113.649Z",
    fill: "url(#paint3_linear_2816_669)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M170.848 84.0449C170.848 91.3483 167.225 95 159.978 95H152.453C145.207 95 141.584 91.3483 141.584 84.0449V45.9551C141.584 38.6517 145.207 35 152.453 35H159.978C167.225 35 170.848 38.6517 170.848 45.9551V84.0449ZM159.142 47.2191C159.142 45.8146 158.446 45.1124 157.052 45.1124H155.38C153.986 45.1124 153.289 45.8146 153.289 47.2191V82.7809C153.289 84.1854 153.986 84.8876 155.38 84.8876H157.052C158.446 84.8876 159.142 84.1854 159.142 82.7809V47.2191Z",
    fill: "url(#paint4_linear_2816_669)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M192.053 94.4944H180.347V46.0393H173.24V35.5056H199.16V46.0393H192.053V94.4944Z",
    fill: "url(#paint5_linear_2816_669)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M213.882 35.5056V94.4944H202.176V35.5056H213.882Z",
    fill: "url(#paint6_linear_2816_669)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M247.276 84.0449C247.276 91.3483 243.653 95 236.406 95H228.881C221.635 95 218.011 91.3483 218.011 84.0449V45.9551C218.011 38.6517 221.635 35 228.881 35H236.406C243.653 35 247.276 38.6517 247.276 45.9551V84.0449ZM235.57 47.2191C235.57 45.8146 234.873 45.1124 233.48 45.1124H231.808C230.414 45.1124 229.717 45.8146 229.717 47.2191V82.7809C229.717 84.1854 230.414 84.8876 231.808 84.8876H233.48C234.873 84.8876 235.57 84.1854 235.57 82.7809V47.2191Z",
    fill: "url(#paint7_linear_2816_669)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M270.059 64.8315L269.809 35.5056H279.926V94.4944H268.554L261.196 62.4719L261.447 94.4944H251.33V35.5056H263.287L270.059 64.8315Z",
    fill: "url(#paint8_linear_2816_669)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M307.318 63.9045C309.101 65.1966 310.328 66.5169 310.997 67.8652C311.666 69.2135 312 70.9831 312 73.1742V84.0449C312 91.3483 308.377 95 301.13 95H294.608C287.362 95 283.739 91.3483 283.739 84.0449V71.4888H295.194V82.9494C295.194 84.3539 295.89 85.0562 297.284 85.0562H298.371C299.765 85.0562 300.461 84.3539 300.461 82.9494V75.8708C300.461 74.2978 299.792 73.0337 298.455 72.0787L288.421 64.5787C286.637 63.2865 285.411 61.9663 284.742 60.618C284.073 59.2135 283.739 57.4438 283.739 55.309V45.9551C283.739 38.6517 287.362 35 294.608 35H300.963C308.209 35 311.833 38.6517 311.833 45.9551V56.7416H300.378V47.0506C300.378 45.6461 299.681 44.9438 298.287 44.9438H297.368C295.974 44.9438 295.277 45.6461 295.277 47.0506V52.6124C295.277 54.1854 295.946 55.4494 297.284 56.4045L307.318 63.9045Z",
    fill: "url(#paint9_linear_2816_669)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M4.14657 136C3.31347 136 2.58451 135.852 1.95968 135.557C1.33486 135.251 0.852035 134.788 0.511221 134.167C0.170407 133.535 0 132.736 0 131.768V125.535C0 125.423 0.0331347 125.331 0.0994041 125.26C0.165674 125.188 0.250877 125.153 0.355015 125.153H1.90288C2.00702 125.153 2.09222 125.188 2.15849 125.26C2.22476 125.331 2.25789 125.423 2.25789 125.535V131.753C2.25789 132.506 2.42357 133.067 2.75491 133.433C3.08626 133.8 3.55015 133.983 4.14657 133.983C4.73353 133.983 5.19268 133.8 5.52403 133.433C5.85538 133.067 6.02105 132.506 6.02105 131.753V125.535C6.02105 125.423 6.05418 125.331 6.12045 125.26C6.19619 125.188 6.28139 125.153 6.37606 125.153H7.93813C8.0328 125.153 8.11327 125.188 8.17954 125.26C8.24581 125.331 8.27894 125.423 8.27894 125.535V131.768C8.27894 132.736 8.10854 133.535 7.76772 134.167C7.42691 134.788 6.94882 135.251 6.33346 135.557C5.7181 135.852 4.98914 136 4.14657 136Z",
    fill: "url(#paint10_linear_2816_669)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0846 135.847C14.9804 135.847 14.8952 135.812 14.829 135.74C14.7627 135.669 14.7296 135.577 14.7296 135.465V125.535C14.7296 125.423 14.7627 125.331 14.829 125.26C14.8952 125.188 14.9804 125.153 15.0846 125.153H16.3768C16.5188 125.153 16.623 125.188 16.6892 125.26C16.7555 125.331 16.7981 125.387 16.817 125.428L20.6086 131.799V125.535C20.6086 125.423 20.6417 125.331 20.708 125.26C20.7743 125.188 20.8547 125.153 20.9494 125.153H22.3979C22.502 125.153 22.5872 125.188 22.6535 125.26C22.7198 125.331 22.7529 125.423 22.7529 125.535V135.465C22.7529 135.567 22.7198 135.659 22.6535 135.74C22.5872 135.812 22.502 135.847 22.3979 135.847H21.0914C20.9494 135.847 20.8453 135.812 20.779 135.74C20.7222 135.659 20.6796 135.603 20.6512 135.572L16.8738 129.4V135.465C16.8738 135.577 16.8407 135.669 16.7744 135.74C16.7082 135.812 16.623 135.847 16.5188 135.847H15.0846Z",
    fill: "url(#paint11_linear_2816_669)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6457 135.847C29.5416 135.847 29.4564 135.812 29.3901 135.74C29.3238 135.669 29.2907 135.577 29.2907 135.465V125.535C29.2907 125.423 29.3238 125.331 29.3901 125.26C29.4564 125.188 29.5416 125.153 29.6457 125.153H33.4089C34.5923 125.153 35.5248 125.448 36.2064 126.039C36.888 126.619 37.2288 127.46 37.2288 128.56C37.2288 129.303 37.0632 129.925 36.7318 130.424C36.4005 130.923 35.9555 131.294 35.397 131.539L37.3992 135.358C37.4276 135.419 37.4418 135.475 37.4418 135.526C37.4418 135.608 37.4134 135.684 37.3566 135.756C37.2998 135.817 37.2288 135.847 37.1436 135.847H35.5674C35.397 135.847 35.2692 135.801 35.184 135.71C35.0987 135.608 35.0372 135.516 34.9993 135.435L33.2669 131.936H31.5486V135.465C31.5486 135.577 31.5155 135.669 31.4492 135.74C31.3829 135.812 31.2977 135.847 31.1936 135.847H29.6457ZM31.5486 129.996H33.3663C33.887 129.996 34.2704 129.869 34.5165 129.614C34.7721 129.359 34.8999 129.003 34.8999 128.544C34.8999 128.086 34.7769 127.725 34.5307 127.46C34.2846 127.195 33.8964 127.062 33.3663 127.062H31.5486V129.996Z",
    fill: "url(#paint12_linear_2816_669)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7631 135.847C43.659 135.847 43.5738 135.812 43.5075 135.74C43.4412 135.669 43.4081 135.577 43.4081 135.465V125.535C43.4081 125.423 43.4412 125.331 43.5075 125.26C43.5738 125.188 43.659 125.153 43.7631 125.153H45.3678C45.4719 125.153 45.5571 125.188 45.6234 125.26C45.6896 125.331 45.7228 125.423 45.7228 125.535V135.465C45.7228 135.577 45.6896 135.669 45.6234 135.74C45.5571 135.812 45.4719 135.847 45.3678 135.847H43.7631Z",
    fill: "url(#paint13_linear_2816_669)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1242 135.847C54.9728 135.847 54.8497 135.806 54.755 135.725C54.6698 135.633 54.6083 135.526 54.5704 135.404L51.5883 125.611C51.5788 125.56 51.5741 125.514 51.5741 125.474C51.5741 125.392 51.6025 125.321 51.6593 125.26C51.7161 125.188 51.7871 125.153 51.8723 125.153H53.3634C53.5054 125.153 53.6142 125.199 53.69 125.29C53.7752 125.372 53.8273 125.448 53.8462 125.519L56.0615 132.99L58.2626 125.519C58.291 125.448 58.343 125.372 58.4188 125.29C58.4945 125.199 58.6034 125.153 58.7454 125.153H60.2364C60.3216 125.153 60.3927 125.188 60.4495 125.26C60.5063 125.321 60.5347 125.392 60.5347 125.474C60.5347 125.514 60.5299 125.56 60.5205 125.611L57.5383 135.404C57.5099 135.526 57.4484 135.633 57.3537 135.725C57.2685 135.806 57.1455 135.847 56.9845 135.847H55.1242Z",
    fill: "url(#paint14_linear_2816_669)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M65.042 135.847C64.9568 135.847 64.8858 135.817 64.829 135.756C64.7722 135.684 64.7438 135.608 64.7438 135.526C64.7438 135.475 64.7485 135.43 64.758 135.389L68.1377 125.565C68.1661 125.453 68.223 125.356 68.3082 125.275C68.3934 125.194 68.5117 125.153 68.6632 125.153H70.4808C70.6323 125.153 70.7507 125.194 70.8359 125.275C70.9211 125.356 70.9779 125.453 71.0063 125.565L74.386 135.389C74.3955 135.43 74.4002 135.475 74.4002 135.526C74.4002 135.608 74.3718 135.684 74.315 135.756C74.2582 135.817 74.1872 135.847 74.102 135.847H72.6251C72.4831 135.847 72.379 135.812 72.3127 135.74C72.2465 135.669 72.2038 135.603 72.1849 135.542L71.5743 133.831H67.5697L66.9591 135.542C66.9402 135.603 66.8976 135.669 66.8313 135.74C66.765 135.812 66.6609 135.847 66.5189 135.847H65.042ZM68.0951 131.86H71.0347L69.572 127.46L68.0951 131.86Z",
    fill: "url(#paint15_linear_2816_669)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4156 135.847C80.3115 135.847 80.2263 135.812 80.16 135.74C80.0937 135.669 80.0606 135.577 80.0606 135.465V125.535C80.0606 125.423 80.0937 125.331 80.16 125.26C80.2263 125.188 80.3115 125.153 80.4156 125.153H81.9919C82.096 125.153 82.1812 125.188 82.2475 125.26C82.3137 125.331 82.3469 125.423 82.3469 125.535V133.8H86.7491C86.8532 133.8 86.9384 133.836 87.0047 133.907C87.0709 133.978 87.1041 134.07 87.1041 134.182V135.465C87.1041 135.577 87.0709 135.669 87.0047 135.74C86.9384 135.812 86.8532 135.847 86.7491 135.847H80.4156Z",
    fill: "url(#paint16_linear_2816_669)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2017 135.847C93.0975 135.847 93.0123 135.812 92.9461 135.74C92.8798 135.669 92.8467 135.577 92.8467 135.465V125.535C92.8467 125.423 92.8798 125.331 92.9461 125.26C93.0123 125.188 93.0975 125.153 93.2017 125.153H99.6345C99.7387 125.153 99.8239 125.188 99.8901 125.26C99.9564 125.331 99.9895 125.423 99.9895 125.535V126.757C99.9895 126.859 99.9564 126.945 99.8901 127.017C99.8239 127.088 99.7387 127.124 99.6345 127.124H95.0335V129.522H99.3221C99.4263 129.522 99.5115 129.558 99.5777 129.629C99.644 129.7 99.6771 129.792 99.6771 129.904V131.035C99.6771 131.137 99.644 131.223 99.5777 131.294C99.5115 131.366 99.4263 131.401 99.3221 131.401H95.0335V133.876H99.7481C99.8523 133.876 99.9375 133.912 100.004 133.983C100.07 134.055 100.103 134.146 100.103 134.258V135.465C100.103 135.577 100.07 135.669 100.004 135.74C99.9375 135.812 99.8523 135.847 99.7481 135.847H93.2017Z",
    fill: "url(#paint17_linear_2816_669)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M106.584 135.847C106.48 135.847 106.395 135.812 106.328 135.74C106.262 135.669 106.229 135.577 106.229 135.465V125.535C106.229 125.423 106.262 125.331 106.328 125.26C106.395 125.188 106.48 125.153 106.584 125.153H110.148C111.095 125.153 111.886 125.316 112.52 125.642C113.154 125.957 113.637 126.426 113.968 127.047C114.309 127.658 114.489 128.417 114.508 129.324C114.517 129.772 114.522 130.164 114.522 130.5C114.522 130.836 114.517 131.223 114.508 131.661C114.48 132.608 114.304 133.393 113.983 134.014C113.661 134.635 113.187 135.099 112.563 135.404C111.938 135.7 111.157 135.847 110.219 135.847H106.584ZM108.487 133.876H110.148C110.622 133.876 111.01 133.8 111.313 133.647C111.616 133.494 111.838 133.255 111.98 132.929C112.132 132.593 112.212 132.16 112.222 131.631C112.231 131.335 112.236 131.07 112.236 130.836C112.245 130.602 112.245 130.368 112.236 130.133C112.236 129.899 112.231 129.639 112.222 129.354C112.203 128.59 112.018 128.03 111.668 127.674C111.327 127.307 110.797 127.124 110.077 127.124H108.487V133.876Z",
    fill: "url(#paint18_linear_2816_669)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M128.662 135.847C128.557 135.847 128.472 135.812 128.406 135.74C128.34 135.669 128.307 135.577 128.307 135.465V125.535C128.307 125.423 128.34 125.331 128.406 125.26C128.472 125.188 128.557 125.153 128.662 125.153H132.538C133.305 125.153 133.968 125.28 134.526 125.535C135.094 125.789 135.535 126.176 135.847 126.696C136.169 127.205 136.33 127.842 136.33 128.606C136.33 129.38 136.169 130.021 135.847 130.531C135.535 131.03 135.094 131.401 134.526 131.646C133.968 131.89 133.305 132.012 132.538 132.012H130.635V135.465C130.635 135.577 130.602 135.669 130.536 135.74C130.47 135.812 130.385 135.847 130.28 135.847H128.662ZM130.593 130.118H132.467C132.95 130.118 133.324 129.991 133.589 129.736C133.864 129.481 134.001 129.1 134.001 128.59C134.001 128.142 133.878 127.775 133.632 127.49C133.395 127.205 133.007 127.062 132.467 127.062H130.593V130.118Z",
    fill: "url(#paint19_linear_2816_669)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M142.571 135.847C142.467 135.847 142.382 135.812 142.315 135.74C142.249 135.669 142.216 135.577 142.216 135.465V125.535C142.216 125.423 142.249 125.331 142.315 125.26C142.382 125.188 142.467 125.153 142.571 125.153H146.334C147.517 125.153 148.45 125.448 149.132 126.039C149.813 126.619 150.154 127.46 150.154 128.56C150.154 129.303 149.988 129.925 149.657 130.424C149.326 130.923 148.881 131.294 148.322 131.539L150.324 135.358C150.353 135.419 150.367 135.475 150.367 135.526C150.367 135.608 150.339 135.684 150.282 135.756C150.225 135.817 150.154 135.847 150.069 135.847H148.493C148.322 135.847 148.194 135.801 148.109 135.71C148.024 135.608 147.962 135.516 147.925 135.435L146.192 131.936H144.474V135.465C144.474 135.577 144.441 135.669 144.374 135.74C144.308 135.812 144.223 135.847 144.119 135.847H142.571ZM144.474 129.996H146.291C146.812 129.996 147.196 129.869 147.442 129.614C147.697 129.359 147.825 129.003 147.825 128.544C147.825 128.086 147.702 127.725 147.456 127.46C147.21 127.195 146.822 127.062 146.291 127.062H144.474V129.996Z",
    fill: "url(#paint20_linear_2816_669)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M156.688 135.847C156.584 135.847 156.499 135.812 156.433 135.74C156.366 135.669 156.333 135.577 156.333 135.465V125.535C156.333 125.423 156.366 125.331 156.433 125.26C156.499 125.188 156.584 125.153 156.688 125.153H158.293C158.397 125.153 158.482 125.188 158.549 125.26C158.615 125.331 158.648 125.423 158.648 125.535V135.465C158.648 135.577 158.615 135.669 158.549 135.74C158.482 135.812 158.397 135.847 158.293 135.847H156.688Z",
    fill: "url(#paint21_linear_2816_669)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M165.025 135.847C164.921 135.847 164.835 135.812 164.769 135.74C164.703 135.659 164.67 135.567 164.67 135.465V134.182C164.67 134.039 164.698 133.922 164.755 133.831C164.812 133.739 164.854 133.673 164.883 133.632L169.654 127.185H165.152C165.058 127.185 164.977 127.149 164.911 127.078C164.845 127.006 164.812 126.92 164.812 126.818V125.535C164.812 125.423 164.845 125.331 164.911 125.26C164.977 125.188 165.058 125.153 165.152 125.153H172.125C172.229 125.153 172.314 125.188 172.381 125.26C172.456 125.331 172.494 125.423 172.494 125.535V126.803C172.494 126.915 172.475 127.017 172.437 127.108C172.4 127.19 172.357 127.261 172.31 127.322L167.666 133.8H172.295C172.4 133.8 172.485 133.836 172.551 133.907C172.617 133.978 172.65 134.07 172.65 134.182V135.465C172.65 135.577 172.617 135.669 172.551 135.74C172.485 135.812 172.4 135.847 172.295 135.847H165.025Z",
    fill: "url(#paint22_linear_2816_669)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M179.015 135.847C178.911 135.847 178.826 135.812 178.76 135.74C178.693 135.669 178.66 135.577 178.66 135.465V125.535C178.66 125.423 178.693 125.331 178.76 125.26C178.826 125.188 178.911 125.153 179.015 125.153H185.448C185.552 125.153 185.638 125.188 185.704 125.26C185.77 125.331 185.803 125.423 185.803 125.535V126.757C185.803 126.859 185.77 126.945 185.704 127.017C185.638 127.088 185.552 127.124 185.448 127.124H180.847V129.522H185.136C185.24 129.522 185.325 129.558 185.391 129.629C185.458 129.7 185.491 129.792 185.491 129.904V131.035C185.491 131.137 185.458 131.223 185.391 131.294C185.325 131.366 185.24 131.401 185.136 131.401H180.847V133.876H185.562C185.666 133.876 185.751 133.912 185.817 133.983C185.884 134.055 185.917 134.146 185.917 134.258V135.465C185.917 135.577 185.884 135.669 185.817 135.74C185.751 135.812 185.666 135.847 185.562 135.847H179.015Z",
    fill: "url(#paint23_linear_2816_669)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M195.621 136C194.712 136 193.95 135.857 193.335 135.572C192.729 135.287 192.27 134.915 191.958 134.457C191.645 133.999 191.479 133.51 191.461 132.99C191.461 132.909 191.489 132.838 191.546 132.776C191.603 132.705 191.674 132.669 191.759 132.669H193.278C193.401 132.669 193.496 132.7 193.562 132.761C193.628 132.812 193.69 132.878 193.747 132.96C193.813 133.133 193.917 133.301 194.059 133.464C194.211 133.627 194.414 133.764 194.67 133.876C194.925 133.978 195.243 134.029 195.621 134.029C196.237 134.029 196.696 133.922 196.999 133.708C197.311 133.494 197.467 133.204 197.467 132.837C197.467 132.573 197.382 132.359 197.212 132.196C197.051 132.033 196.79 131.885 196.431 131.753C196.08 131.62 195.612 131.478 195.025 131.325C194.315 131.162 193.709 130.953 193.207 130.699C192.715 130.434 192.341 130.098 192.085 129.69C191.839 129.273 191.716 128.758 191.716 128.147C191.716 127.536 191.872 126.996 192.185 126.528C192.497 126.049 192.937 125.677 193.505 125.413C194.073 125.138 194.75 125 195.536 125C196.17 125 196.729 125.092 197.212 125.275C197.704 125.458 198.111 125.698 198.433 125.993C198.764 126.288 199.015 126.604 199.186 126.94C199.356 127.276 199.446 127.602 199.455 127.918C199.455 128 199.427 128.076 199.37 128.147C199.313 128.208 199.242 128.239 199.157 128.239H197.567C197.472 128.239 197.387 128.219 197.311 128.178C197.235 128.137 197.174 128.066 197.127 127.964C197.07 127.699 196.899 127.47 196.615 127.276C196.341 127.073 195.981 126.971 195.536 126.971C195.072 126.971 194.703 127.062 194.428 127.246C194.163 127.429 194.031 127.709 194.031 128.086C194.031 128.331 194.097 128.539 194.23 128.713C194.372 128.875 194.604 129.023 194.925 129.156C195.257 129.278 195.692 129.415 196.232 129.568C197.065 129.751 197.742 129.97 198.263 130.225C198.783 130.48 199.167 130.811 199.413 131.218C199.659 131.615 199.782 132.119 199.782 132.731C199.782 133.413 199.602 133.999 199.242 134.488C198.892 134.976 198.405 135.353 197.78 135.618C197.164 135.873 196.445 136 195.621 136Z",
    fill: "url(#paint24_linear_2816_669)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M216.468 136C215.758 136 215.138 135.878 214.608 135.633C214.078 135.379 213.666 135.017 213.373 134.549C213.079 134.08 212.932 133.53 212.932 132.899C212.932 132.45 213.013 132.053 213.174 131.707C213.344 131.361 213.576 131.05 213.87 130.775C214.163 130.49 214.499 130.23 214.878 129.996C214.49 129.548 214.211 129.14 214.04 128.774C213.879 128.407 213.799 128.03 213.799 127.643C213.799 127.175 213.912 126.742 214.14 126.344C214.367 125.947 214.703 125.626 215.148 125.382C215.593 125.127 216.137 125 216.781 125C217.387 125 217.903 125.122 218.329 125.367C218.755 125.601 219.081 125.917 219.309 126.314C219.536 126.711 219.649 127.144 219.649 127.612C219.649 128.03 219.559 128.407 219.38 128.743C219.209 129.069 218.972 129.364 218.67 129.629C218.367 129.894 218.021 130.149 217.633 130.393L219.493 132.394C219.588 132.221 219.706 131.982 219.848 131.676C219.99 131.371 220.118 130.979 220.232 130.5C220.26 130.337 220.359 130.256 220.53 130.256H221.765C221.85 130.256 221.917 130.286 221.964 130.347C222.021 130.398 222.049 130.469 222.049 130.561C222.04 130.755 221.997 130.984 221.921 131.249C221.846 131.503 221.742 131.773 221.609 132.058C221.477 132.344 221.33 132.624 221.169 132.899C221.008 133.174 220.847 133.428 220.686 133.662L222.234 135.343C222.3 135.425 222.333 135.501 222.333 135.572C222.333 135.654 222.31 135.72 222.262 135.771C222.215 135.822 222.149 135.847 222.063 135.847H220.43C220.336 135.847 220.26 135.832 220.203 135.801C220.146 135.761 220.094 135.725 220.047 135.694L219.337 134.961C218.958 135.297 218.532 135.557 218.059 135.74C217.595 135.913 217.065 136 216.468 136ZM216.468 134.243C216.781 134.243 217.074 134.192 217.349 134.09C217.633 133.978 217.893 133.8 218.13 133.556L216.028 131.34C215.735 131.513 215.484 131.722 215.276 131.967C215.067 132.201 214.963 132.486 214.963 132.822C214.963 133.118 215.034 133.372 215.176 133.586C215.318 133.8 215.503 133.963 215.73 134.075C215.967 134.187 216.213 134.243 216.468 134.243ZM216.525 129.125C216.762 128.982 216.98 128.845 217.178 128.713C217.377 128.57 217.533 128.417 217.647 128.254C217.761 128.081 217.817 127.888 217.817 127.674C217.817 127.358 217.718 127.108 217.519 126.925C217.32 126.742 217.074 126.65 216.781 126.65C216.506 126.65 216.265 126.742 216.057 126.925C215.848 127.108 215.744 127.358 215.744 127.674C215.744 127.816 215.768 127.959 215.815 128.101C215.863 128.234 215.943 128.381 216.057 128.544C216.17 128.707 216.326 128.901 216.525 129.125Z",
    fill: "url(#paint25_linear_2816_669)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M236.053 135.847C235.949 135.847 235.864 135.812 235.798 135.74C235.732 135.669 235.698 135.577 235.698 135.465V125.535C235.698 125.423 235.732 125.331 235.798 125.26C235.864 125.188 235.949 125.153 236.053 125.153H242.486C242.59 125.153 242.676 125.188 242.742 125.26C242.808 125.331 242.841 125.423 242.841 125.535V126.757C242.841 126.859 242.808 126.945 242.742 127.017C242.676 127.088 242.59 127.124 242.486 127.124H237.885V129.522H242.174C242.278 129.522 242.363 129.558 242.43 129.629C242.496 129.7 242.529 129.792 242.529 129.904V131.035C242.529 131.137 242.496 131.223 242.43 131.294C242.363 131.366 242.278 131.401 242.174 131.401H237.885V133.876H242.6C242.704 133.876 242.789 133.912 242.856 133.983C242.922 134.055 242.955 134.146 242.955 134.258V135.465C242.955 135.577 242.922 135.669 242.856 135.74C242.789 135.812 242.704 135.847 242.6 135.847H236.053Z",
    fill: "url(#paint26_linear_2816_669)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M251.88 135.847C251.729 135.847 251.605 135.806 251.511 135.725C251.426 135.633 251.364 135.526 251.326 135.404L248.344 125.611C248.335 125.56 248.33 125.514 248.33 125.474C248.33 125.392 248.358 125.321 248.415 125.26C248.472 125.188 248.543 125.153 248.628 125.153H250.119C250.261 125.153 250.37 125.199 250.446 125.29C250.531 125.372 250.583 125.448 250.602 125.519L252.817 132.99L255.018 125.519C255.047 125.448 255.099 125.372 255.175 125.29C255.25 125.199 255.359 125.153 255.501 125.153H256.992C257.077 125.153 257.148 125.188 257.205 125.26C257.262 125.321 257.29 125.392 257.29 125.474C257.29 125.514 257.286 125.56 257.276 125.611L254.294 135.404C254.266 135.526 254.204 135.633 254.11 135.725C254.024 135.806 253.901 135.847 253.74 135.847H251.88Z",
    fill: "url(#paint27_linear_2816_669)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M263.498 135.847C263.394 135.847 263.308 135.812 263.242 135.74C263.176 135.669 263.143 135.577 263.143 135.465V125.535C263.143 125.423 263.176 125.331 263.242 125.26C263.308 125.188 263.394 125.153 263.498 125.153H269.931C270.035 125.153 270.12 125.188 270.186 125.26C270.253 125.331 270.286 125.423 270.286 125.535V126.757C270.286 126.859 270.253 126.945 270.186 127.017C270.12 127.088 270.035 127.124 269.931 127.124H265.33V129.522H269.618C269.722 129.522 269.808 129.558 269.874 129.629C269.94 129.7 269.973 129.792 269.973 129.904V131.035C269.973 131.137 269.94 131.223 269.874 131.294C269.808 131.366 269.722 131.401 269.618 131.401H265.33V133.876H270.044C270.148 133.876 270.234 133.912 270.3 133.983C270.366 134.055 270.399 134.146 270.399 134.258V135.465C270.399 135.577 270.366 135.669 270.3 135.74C270.234 135.812 270.148 135.847 270.044 135.847H263.498Z",
    fill: "url(#paint28_linear_2816_669)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M276.88 135.847C276.776 135.847 276.691 135.812 276.625 135.74C276.558 135.669 276.525 135.577 276.525 135.465V125.535C276.525 125.423 276.558 125.331 276.625 125.26C276.691 125.188 276.776 125.153 276.88 125.153H278.172C278.314 125.153 278.419 125.188 278.485 125.26C278.551 125.331 278.594 125.387 278.613 125.428L282.404 131.799V125.535C282.404 125.423 282.437 125.331 282.504 125.26C282.57 125.188 282.65 125.153 282.745 125.153H284.193C284.298 125.153 284.383 125.188 284.449 125.26C284.515 125.331 284.548 125.423 284.548 125.535V135.465C284.548 135.567 284.515 135.659 284.449 135.74C284.383 135.812 284.298 135.847 284.193 135.847H282.887C282.745 135.847 282.641 135.812 282.575 135.74C282.518 135.659 282.475 135.603 282.447 135.572L278.669 129.4V135.465C278.669 135.577 278.636 135.669 278.57 135.74C278.504 135.812 278.419 135.847 278.314 135.847H276.88Z",
    fill: "url(#paint29_linear_2816_669)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M293.628 135.847C293.524 135.847 293.439 135.812 293.373 135.74C293.306 135.669 293.273 135.577 293.273 135.465V127.276H290.689C290.594 127.276 290.514 127.241 290.447 127.169C290.381 127.098 290.348 127.012 290.348 126.91V125.535C290.348 125.423 290.381 125.331 290.447 125.26C290.514 125.188 290.594 125.153 290.689 125.153H298.13C298.234 125.153 298.319 125.188 298.385 125.26C298.452 125.331 298.485 125.423 298.485 125.535V126.91C298.485 127.012 298.452 127.098 298.385 127.169C298.319 127.241 298.234 127.276 298.13 127.276H295.559V135.465C295.559 135.577 295.526 135.669 295.46 135.74C295.394 135.812 295.309 135.847 295.204 135.847H293.628Z",
    fill: "url(#paint30_linear_2816_669)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M307.839 136C306.93 136 306.168 135.857 305.553 135.572C304.947 135.287 304.488 134.915 304.175 134.457C303.863 133.999 303.697 133.51 303.678 132.99C303.678 132.909 303.707 132.838 303.764 132.776C303.82 132.705 303.891 132.669 303.977 132.669H305.496C305.619 132.669 305.714 132.7 305.78 132.761C305.846 132.812 305.908 132.878 305.965 132.96C306.031 133.133 306.135 133.301 306.277 133.464C306.429 133.627 306.632 133.764 306.888 133.876C307.143 133.978 307.461 134.029 307.839 134.029C308.455 134.029 308.914 133.922 309.217 133.708C309.529 133.494 309.685 133.204 309.685 132.837C309.685 132.573 309.6 132.359 309.43 132.196C309.269 132.033 309.008 131.885 308.649 131.753C308.298 131.62 307.83 131.478 307.243 131.325C306.533 131.162 305.927 130.953 305.425 130.699C304.933 130.434 304.559 130.098 304.303 129.69C304.057 129.273 303.934 128.758 303.934 128.147C303.934 127.536 304.09 126.996 304.403 126.528C304.715 126.049 305.155 125.677 305.723 125.413C306.291 125.138 306.968 125 307.754 125C308.388 125 308.947 125.092 309.43 125.275C309.922 125.458 310.329 125.698 310.651 125.993C310.982 126.288 311.233 126.604 311.404 126.94C311.574 127.276 311.664 127.602 311.673 127.918C311.673 128 311.645 128.076 311.588 128.147C311.531 128.208 311.46 128.239 311.375 128.239H309.785C309.69 128.239 309.605 128.219 309.529 128.178C309.453 128.137 309.392 128.066 309.344 127.964C309.288 127.699 309.117 127.47 308.833 127.276C308.559 127.073 308.199 126.971 307.754 126.971C307.29 126.971 306.921 127.062 306.646 127.246C306.381 127.429 306.249 127.709 306.249 128.086C306.249 128.331 306.315 128.539 306.448 128.713C306.59 128.875 306.822 129.023 307.143 129.156C307.475 129.278 307.91 129.415 308.45 129.568C309.283 129.751 309.96 129.97 310.481 130.225C311.001 130.48 311.385 130.811 311.631 131.218C311.877 131.615 312 132.119 312 132.731C312 133.413 311.82 133.999 311.46 134.488C311.11 134.976 310.623 135.353 309.998 135.618C309.382 135.873 308.663 136 307.839 136Z",
    fill: "url(#paint31_linear_2816_669)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 109.5,
    x2: 310,
    y2: 109.5,
    stroke: "url(#paint32_linear_2816_669)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2816_669",
    x: 327,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2816_669"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2816_669",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2816_669",
    x: 306,
    y: 2,
    width: 23,
    height: 23,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2816_669"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2816_669",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2816_669",
    x: 310,
    y: 20,
    width: 27,
    height: 27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2816_669"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2816_669",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2816_669",
    x1: 156,
    y1: 35,
    x2: 156,
    y2: 95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.78
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2816_669",
    x1: 156,
    y1: 35,
    x2: 156,
    y2: 95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.78
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2816_669",
    x1: 156,
    y1: 35,
    x2: 156,
    y2: 95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.78
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2816_669",
    x1: 156,
    y1: 35,
    x2: 156,
    y2: 95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.78
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2816_669",
    x1: 156,
    y1: 35,
    x2: 156,
    y2: 95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.78
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2816_669",
    x1: 156,
    y1: 35,
    x2: 156,
    y2: 95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.78
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2816_669",
    x1: 156,
    y1: 35,
    x2: 156,
    y2: 95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.78
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2816_669",
    x1: 156,
    y1: 35,
    x2: 156,
    y2: 95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.78
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2816_669",
    x1: 156,
    y1: 35,
    x2: 156,
    y2: 95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.78
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2816_669",
    x1: 156,
    y1: 35,
    x2: 156,
    y2: 95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.78
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2816_669",
    x1: 156,
    y1: 125,
    x2: 156,
    y2: 136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7B51E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2816_669",
    x1: 156,
    y1: 125,
    x2: 156,
    y2: 136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7B51E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2816_669",
    x1: 156,
    y1: 125,
    x2: 156,
    y2: 136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7B51E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2816_669",
    x1: 156,
    y1: 125,
    x2: 156,
    y2: 136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7B51E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2816_669",
    x1: 156,
    y1: 125,
    x2: 156,
    y2: 136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7B51E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2816_669",
    x1: 156,
    y1: 125,
    x2: 156,
    y2: 136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7B51E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2816_669",
    x1: 156,
    y1: 125,
    x2: 156,
    y2: 136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7B51E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2816_669",
    x1: 156,
    y1: 125,
    x2: 156,
    y2: 136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7B51E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2816_669",
    x1: 156,
    y1: 125,
    x2: 156,
    y2: 136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7B51E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2816_669",
    x1: 156,
    y1: 125,
    x2: 156,
    y2: 136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7B51E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2816_669",
    x1: 156,
    y1: 125,
    x2: 156,
    y2: 136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7B51E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2816_669",
    x1: 156,
    y1: 125,
    x2: 156,
    y2: 136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7B51E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2816_669",
    x1: 156,
    y1: 125,
    x2: 156,
    y2: 136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7B51E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2816_669",
    x1: 156,
    y1: 125,
    x2: 156,
    y2: 136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7B51E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2816_669",
    x1: 156,
    y1: 125,
    x2: 156,
    y2: 136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7B51E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2816_669",
    x1: 156,
    y1: 125,
    x2: 156,
    y2: 136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7B51E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2816_669",
    x1: 156,
    y1: 125,
    x2: 156,
    y2: 136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7B51E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2816_669",
    x1: 156,
    y1: 125,
    x2: 156,
    y2: 136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7B51E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2816_669",
    x1: 156,
    y1: 125,
    x2: 156,
    y2: 136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7B51E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2816_669",
    x1: 156,
    y1: 125,
    x2: 156,
    y2: 136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7B51E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2816_669",
    x1: 156,
    y1: 125,
    x2: 156,
    y2: 136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7B51E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2816_669",
    x1: 156,
    y1: 125,
    x2: 156,
    y2: 136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD94A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7B51E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2816_669",
    x1: 0,
    y1: 110,
    x2: 310,
    y2: 110,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F5F5",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromoText);
export default __webpack_public_path__ + "static/media/promo-text.6f0b430eca9b82ac0e8133eafa8e1402.svg";
export { ForwardRef as ReactComponent };